import { defineKey as T } from '@ha/intl';
import { FeaturedCountries } from 'ha/constants/FeaturedCountries';

export const showRegistration = (countryCode: string) => {
  const isFeaturedCountry = FeaturedCountries.includes(countryCode);

  // featured cities without registration
  const countriesWithoutRegistration = ['fr', 'es'];

  return (
    isFeaturedCountry && !countriesWithoutRegistration.includes(countryCode)
  );
};

const RegistrationLocalTranslation = {
  at: T('registration_austria'),
  be: T('registration_belgium'),
  ch: T('registration_switzerland'),
  de: T('registration_germany'),
  is: T('registration_iceland'),
  it: T('registration_italy'),
  nl: T('registration_netherlands'),
  pt: T('registration_portugal'),
};

export const getLocalRegistrationTranslationByCountry = (countryCode: string) =>
  RegistrationLocalTranslation[countryCode] || '';

const RegistrationDescriptionLocalTranslation = {
  at: T('tenant.registration_info.austria'),
  be: T('tenant.registration_info.belgium'),
  ch: T('tenant.registration_info.switzerland'),
  de: T('tenant.registration_info.germany'),
  is: T('tenant.registration_info.iceland'),
  it: T('tenant.registration_info.italy'),
  nl: T('tenant.registration_info.netherlands'),
  pt: T('tenant.registration_info.portugal'),
};

export const getLocalRegistrationDescriptionTranslationByCountry = (
  countryCode: string,
) => RegistrationDescriptionLocalTranslation[countryCode] || '';
